export class RadioCheckBoxEnum {

    public static travauxValue = 'travaux';
    public static servicesValue = 'services';
    public static fournituresValue = 'fournitures';


    public static conceptionRealisation = 'conceptionRealisation';
    public static execution = 'execution';
    public static executionOuvrage = 'executionOuvrage';

    public static achatValue = 'achat';
    public static creditBailValue = 'creditBail';
    public static locationValue = 'location';
    public static locationVenteValue = 'locationVente';
    public static plusieursFormesValue = 'plusieursFormes';

    public static ouiValue = 'Oui';
    public static nonValue = 'Non';

    public static emptyValue = '';

    public static avisPreInfoValue = 'avisPreInfo';
    public static avisInfoConcurrenceValue = 'avisInfoConcurrence';
    public static avisProfilAcheteurValue = 'avisProfilAcheteur';

    public static typecrjugement = 'typecrjugement';
    public static criterecdc = 'criterecdc';
    public static criterepondere = 'criterepondere';
    
    public static criterelibre = 'criterelibre';
    public static critereprix = 'critereprix';
    public static autresOrganismesPublics = 'autresOrganismesPublics';
    public static commune = 'commune';
    public static debiteurEtranger = 'debiteurEtranger';
    public static debiteurPrivePersMorale = 'debiteurPrivePersMorale';
    public static debiteurPrivePersPhysique = 'debiteurPrivePersPhysique';
    public static departement = 'departement';
    public static etablissementsPublicsSante = 'etablissementsPublicsSante';
    public static etat = 'etat';
    public static groupementCollectivites = 'groupementCollectivites';
    public static region = 'region';

    public static affairesEcoFi = 'affairesEcoFi';
    public static autre = 'autre';
    public static defense = 'defense';
    public static education = 'education';
    public static environnement = 'environnement';
    public static logementDevCol = 'logementDevCol';
    public static loisirsCultureReligion = 'loisirsCultureReligion';
    public static ordreSecuritePub = 'ordreSecuritePub';
    public static protectionSociale = 'protectionSociale';
    public static sante = 'sante';
    public static servicesGenerauxAdmPub = 'servicesGenerauxAdmPub';

    public static gazChaleur = 'gazChaleur';
    public static gazPetrole = 'gazPetrole';
    public static electricite = 'electricite';
    public static combustiblesSolides = 'combustiblesSolides';
    public static eau = 'eau';
    public static servicesPostaux = 'servicesPostaux';
    public static servicesCheminFer = 'servicesCheminFer';
    public static servicesCheminFerUrbains = 'servicesCheminFerUrbains';
    public static activitesPortuaires = 'activitesPortuaires';
    public static activitesAeroportuaires = 'activitesAeroportuaires';

    public static appelRestreintAccelere = 'appelRestreintAccelere';
    public static dialogueCompetitif = 'dialogueCompetitif';
    public static marcheNegocieAccelere = 'marcheNegocieAccelere';
    public static appelRestreint = 'appelRestreint';
    public static marcheNegociePublication = 'marcheNegociePublication';
    public static negocieSansPublication = 'negocieSansPublication';

    public static lire = 'lire';
    public static ajouter = 'ajouter';
    public static supprimer = 'etat';

    public static unLot = 'unLot';
    public static plusieursLots = 'plusieursLots';
    public static tousLesLots = 'tousLesLots';
    
    public static infructueux = 'infructueux';
    public static sansSuite = 'sansSuite';
    public static attribueUnique = 'attribueUnique';
    public static attribueLots = 'attribueLots';
    public static lotsInfructueux = 'lotsInfructueux';
    public static attribue = 'attribue';

    public static critereAucun = 'critereAucun';
    public static critereCdc = 'critereCdc';
    public static criterePondere = 'criterePondere';
    public static critereLibre = 'critereLibre';
    public static criterePrix = 'criterePrix';

    public static infructueuxRestreinte = 'infructueuxRestreinte';
    public static infructueuxNegociee = 'infructueuxNegociee';
    public static infructueuxCompetitif = 'infructueuxCompetitif';

    public static siretValue = 'siret';
    public static sirenValue = 'siren';
    public static ridetValue = 'ridet';
    public static tahitiValue = 'tahiti';
    public static frwfValue = 'frwf';
    public static irepValue = 'irep';
    public static tvaIntraValue = 'tvaIntra';

    public static accordCadreValue = 'accordCadre';
	public static sysQualiValue = 'sysQuali';
	public static sadValue = 'sad';
	public static concoursValue = 'concours';
	public static catalogueElecValue = 'catalogueElec';
	public static enchereElecValue = 'enchereElec';
	public static autresValue = 'autres';

    public static procedureAdapteeOValue = 'procedureAdapteeO';
	public static procedureAdapteeRValue = 'procedureAdapteeR';

    public static exigeeValue = 'exigee';
	public static autoriseeValue = 'autorisee';
	public static interditeValue = 'interdite';

    public static urlProfilAchValue = 'urlProfilAch';
    public static urlDocConsulValue = 'urlDocConsul';
    public static autreValue = 'autre';

    public static entrepriseAdapteeValue = 'entrepriseAdaptee';
    public static servicesSociauxValue = 'servicesSociaux';
    public static structureInsertionValue = 'structureInsertion';

    public static totaliteValue = 'enTotalite';
    public static partieValue = 'enPartie';
}